<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2024-01-04 18:20:13
-->
<template>
  <div id="box" class="box">
    <div id="left" class="left">
      <div style="font-weight:600;" class="title">站点栏目</div>
      <div class="search">
        <a-input-search
          v-model:value="value"
          placeholder="搜索栏目"
          size="large"
        >
          <template #enterButton>
            <img @click="search" class="img" src="@/assets/images/search.jpg" />
          </template>
        </a-input-search>
      </div>
      <div @click="closeAll">
        <img class="close-img" src="@/assets/images/close.jpg" /><span
          class="close-name"
          >全部收缩</span
        >
      </div>
       <a-spin :spinning="treeLoading">
      <div class="ant-tree">
        <a-tree
          ref="tree"
          :style="{height:heightLeft,overflowY:'auto',overflowX:'hidden'}"
          show-line
          :tree-data="treeData"
          v-if="treeData.length > 0"
          @select="onSelect"
          :auto-expand-parent="isCloseAll"
          :defaultExpandedKeys="defaultExpandedKeys"
          :selectedKeys="checkedKeys"
          :expanded-keys="expandedKeys"
          :default-expanded-keys="columnOpenIds"
          @expand="onExpand"
        >
          <template  slot-scope="text" slot="child">
               <a-icon   class="icon-box-img"  type="link" />
           </template>
  	     
        </a-tree>
      </div>
      </a-spin>
    </div>
     <div id="resize"></div>
    <div id="right" class="right">
      <div class="right-title-box">
           <div style="font-weight: 600;" class="right-name">栏目稿件-{{ columnName }}</div>
           <div class="right-title-box-txt"><span :title="`栏目属性：${columnItemData.openType==0?'本窗口打开':'新窗口打开'}、${columnItemData.sortType==0?'按时间排序':'手动排序'}${columnItemData.importParentName?`、${columnItemData.importParentName}`:''}${columnItemData.pushParentName?`、${columnItemData.pushParentName}`:''}`">栏目属性：{{columnItemData.openType==0?'本窗口打开':'新窗口打开'}}<span>、{{columnItemData.sortType==0?'按时间排序':'手动排序'}}</span><span v-if="columnItemData.importParentName">、{{columnItemData.importParentName}}</span><span v-if="columnItemData.pushParentName">、{{columnItemData.pushParentName}}</span></span></div>
      </div>
      <div class="right-flex">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item v-if="codeData.indexOf('37') != -1" key="1">
              发布</a-menu-item
            >
            <a-menu-item v-if="codeData.indexOf('38') != -1" key="2">
              下线</a-menu-item
            >
             <a-menu-item
              @click="removeColumn"
              key="3"
            >
              移出栏目</a-menu-item
            >
            <a-menu-item
              v-if="codeData.indexOf('280') != -1"
              @click="caoSong"
              key="4"
            >
              抄送栏目</a-menu-item
            >
             <a-menu-item
              v-if="codeData.indexOf('344') != -1"
              @click="manuscriptMigration"
              key="5"
            >
              稿件迁移</a-menu-item
            >
            
          </a-menu>
          <a-button
            v-show="codeData.indexOf('35') != -1"
            class="btn-p"
            style="margin-left: 8px;margin-bottom:20px"
          >
            批量操作 <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <div class="search">
           
                 <a-range-picker  style="margin-right:8px;max-width:350px" showTime v-model="timeTwo" format="YYYY-MM-DD HH:mm:ss"/>
          <!-- <el-select style="margin-right: 12px" v-model="sortValue">
            <el-option label="默认排序" value="0" />
            <el-option label="发布时间由近及远" value="1" />
            <el-option label="发布时间由远及近" value="2" />
          </el-select> -->
          <!-- <el-date-picker
            v-model="time"
            type="date"
            style="margin-right: 12px"
            placeholder="请选择发布时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker> -->
          <el-select
            clearable
            multiple
            collapse-tags
            style="margin-right: 8px"
            v-model="states"
            placeholder="按稿件状态筛选"
          >
            <el-option label="已发布" value="4"> </el-option>
            <el-option label="已下线" value="5"> </el-option>
            <el-option label="审核通过" value="2"> </el-option>
        </el-select>
        <el-select
            clearable
            multiple
            collapse-tags
            style="margin-right: 8px"
            v-model="statesImportState"
            placeholder="按稿件类型筛选"
          >
            <el-option label="引用" value="1"> </el-option>
            <el-option label="推送" value="2"> </el-option>
        </el-select>
          <a-input
            v-model:value="valueName"
            placeholder="按标题搜索"
            style="max-width:173px;"
          />
            <el-button class="search-box" type="primary"  @click="listSearch"
          ></span>查询</el-button
        >
        </div>
      </div>
      <coententTable
        :y="height"
        @handleTableChange="handleTableChange"
        @onShowSizeChange="onShowSizeChange"
        :columns="columns"
        :dataSource="dataSource"
        :customSlot="customSlot"
        :isSelectRow="isSelectRow"
        @selectedRowKeys="selectedRowKeys"
        @handleSizeChange="handleSizeChange"
        :loading="loading"
        :rowKeys="rowKeys"
        sortId="sortId"
        disRow=""
        :disState="[]"
      >
        <template v-slot:titleTwo="scopeVal">
          <div style="display: flex">
            <div
              v-if="scopeVal.scope.columnState == 2"
              style="width:60px"
              class="title-box"
            >
              审核通过
            </div>
            <div v-if="scopeVal.scope.columnState == 4" class="title-box">
              已发布
            </div>
            <div
              v-if="scopeVal.scope.columnState == 5"
              class="title-box-two"
            >
              已下线
            </div>
            <div
              v-if="scopeVal.scope.importState == 1"
              class="tui-song"
            >
              引用
            </div>
            <div v-if="scopeVal.scope.topState == 2" class="zhi-ding">置顶</div>
             <div v-if="scopeVal.scope.importState == 2"  class="tui-song">推送</div>
            <div
              v-if="scopeVal.scope.columnState == 4"
              @click="toPath(scopeVal.scope)"
              class="overflow"
            >
              <span :title="scopeVal.scope.title"
                ><a style="margin-left: 10px; text-decoration: underline">{{
                  scopeVal.scope.title
                }}</a></span
              >
            </div>
            <div
              v-if="
                scopeVal.scope.columnState != 4 &&
                scopeVal.scope.columnState != 5
              "
              class="overflow"
            >
              <span :title="scopeVal.scope.title"
                ><a style="margin-left: 10px; text-decoration: underline">{{
                  scopeVal.scope.title
                }}</a></span
              >
            </div>
            <div
              v-if="scopeVal.scope.columnState == 5"
              @click="toPathId(scopeVal.scope)"
              class="overflow"
            >
              <span :title="scopeVal.scope.title"
                ><a style="margin-left: 10px; text-decoration: underline">{{
                  scopeVal.scope.title
                }}</a></span
              >
            </div>
          </div>
        </template>
        <template v-slot:sort="scopeVal">
          <div class="sort">
            <div  class="sort-box">
               <div  class="sort-two" v-if="codeData.indexOf('180') != -1">
                  <a-button @click="sort(scopeVal.scope, true)" :disabled="!isDisabled">
                     <i   class="ri-arrow-up-line"></i>
                  </a-button>
                 
                </div>
            </div>
            <input
              v-if="scopeVal.scope.topState == 2"
              disabled
              v-model="scopeVal.scope.topSort"
              class="sort-style"
            />
            <input
              v-if="scopeVal.scope.topState == 1"
              disabled
              v-model="scopeVal.scope.sort"
              class="sort-style"
            />
            <div class="sort-box-two">
              <div   class="sort-two" v-if="codeData.indexOf('181') != -1">
                   <a-button @click="sort(scopeVal.scope, false)" :disabled="!isDisabled">
                      <i    class="ri-arrow-down-line"></i>
                  </a-button>
                </div>
            </div>
          </div>
        </template>
        <template v-slot:stateRizhi="scopeVal">
          <a-popover placement="bottom" trigger="click">
            <div class="content" slot="content">
              <div style="margin-bottom: 10px">操作时间</div>
              <table class="table_one" border="1">
                <tr>
                  <th class="table-th">时间</th>
                  <th class="table-tn">操作人</th>
                  <th class="table-tn">操作项</th>
                </tr>
                <tr v-for="item in seeData">
                  <td class="table-tn">{{ item.time }}</td>
                  <td class="table-tn">{{ item.name }}</td>
                  <td class="table-tn">{{ item.content }}</td>
                </tr>
              </table>
            </div>
            <a v-if="codeData.indexOf('36') != -1" @click="see(scopeVal.scope)"
              >查看</a
            >
          </a-popover>
        </template>
        <template v-slot:operation="scopeVal">
           <div style="display: flex">
               <div
            class="btnFour"
            style="margin-right:14px"
            v-if="
              (scopeVal.scope.columnState == 4 ||
                scopeVal.scope.importState == 1) &&
              codeData.indexOf('37') != -1
            "
            >发布</div
          >
          <div
            v-if="
              scopeVal.scope.columnState == 4 &&
              codeData.indexOf('38') != -1 &&
              scopeVal.scope.importState != 1
            "
            @click="setOffline(scopeVal.scope)"
            class="btnTwo"
             style="margin-right:14px"
            >下线</div
          >

          <div
            class="btnTwo"
             style="margin-right:14px"
            v-if="
              (scopeVal.scope.columnState == 2 ||
                scopeVal.scope.columnState == 5) &&
              codeData.indexOf('37') != -1 &&
              scopeVal.scope.importState != 1
            "
            @click="setRelease(scopeVal.scope)"
            >发布</div
          >
          <div
            v-if="
              (scopeVal.scope.columnState == 2 ||
                scopeVal.scope.columnState == 5 ||
                scopeVal.scope.importState == 1) &&
              codeData.indexOf('38') != -1
            "
            class="btnFour"
             style="margin-right:14px"
            >下线</div
          >

          <div class="dropBox">
              <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <a
                  v-if="
                    codeData.indexOf('39') != -1 &&
                    scopeVal.scope.importState != 1
                  "
                  @click="editAdmin(scopeVal.scope)"
                  class="btn"
                  style="margin-right: 20px"
                  >编辑</a
                >
                <a
                  v-if="
                    codeData.indexOf('39') != -1 &&
                    (scopeVal.scope.importState == 1)
                  "
                  class="btn"
                  style="color: #ccc; margin-right: 20px"
                  >编辑</a
                >
              </a-menu-item>
              <a-menu-item key="2">
                <a
                  v-if="
                    codeData.indexOf('277') != -1 &&
                    scopeVal.scope.topState == 1
                  "
                  @click="zhiDing(scopeVal.scope)"
                  class="btn"
                  >置顶</a
                >
                <!-- <a
                  v-if="
                    codeData.indexOf('277') != -1 &&
                    scopeVal.scope.topState == 1 &&
                    scopeVal.scope.importState == 1
                  "
                  class="btn"
                  style="color: #ccc"
                  >置顶</a
                > -->
                <a
                  v-if="
                    codeData.indexOf('278') != -1 &&
                    scopeVal.scope.topState == 2
                  "
                  @click="quZhiDing(scopeVal.scope)"
                  class="btn"
                  >取消置顶</a
                >
                <!-- <a
                  v-if="
                    codeData.indexOf('278') != -1 &&
                    scopeVal.scope.topState == 2 &&
                    scopeVal.scope.importState == 1
                  "
                  style="color: #ccc"
                  class="btn"
                  >取消置顶</a
                > -->
              </a-menu-item>
              <a-menu-item v-if="scopeVal.scope.columnState == 5 &&  codeData.indexOf('312') != -1" key="3">
                 <a
                    @click="open(scopeVal.scope)"
                    class="btn"
                    >移出</a
                  >
              </a-menu-item>
              <a-menu-item v-if="scopeVal.scope.columnState != 5 &&  codeData.indexOf('312') != -1" key="3">
                 <a
                   style="color: #ccc"
                    class="btn"
                    >移出</a
                  >
              </a-menu-item>
              <a-menu-item v-if="scopeVal.scope.importState == 0 && codeData.indexOf('344') != -1"  key="4">
                 <a
                    @click="migrate(scopeVal.scope)"
                    class="btn"
                    >迁移</a
                  >
              </a-menu-item>
              <a-menu-item v-if="codeData.indexOf('344') != -1 && scopeVal.scope.importState != 0"  key="4">
                 <a
                   style="color: #ccc"
                    class="btn"
                    >迁移</a
                  >
              </a-menu-item>
            </a-menu>
            <div class="btnTwo"
              >更多<a-icon type="down" />
            </div>
          </a-dropdown>
          </div>
           </div>

          
        </template>
      </coententTable>
      <div id="pagination" class="pagination">
        <a-pagination
          :current="pagination.current"
          :pageSize="pagination.pageSize"
          show-size-changer
          show-quick-jumper
          :total="pagination.total"
          @change="onShowSizeChange"
          @showSizeChange="handleSizeChange"
          :page-size-options="pagination.pageSizeOptions"
          :show-total="(total) => `共 ${pagination.total} 条`"
        />
      </div>
    </div>
    <div class="choose-column-box">
        <choose-column
          :isColumn="isColumn"
          @colseChooseColumn="colseChooseColumn"
          @setColumnIds="setColumnIds"
          ref="chooseColumn"
          v-if="isColumn"
          :isCaoSong="true"
          title="抄送栏目"
        ></choose-column>
    </div>
    <el-dialog
      title="确认移出稿件?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>移除后，该稿件将不在本栏目中显示，是否移除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteOne()">确认移出</el-button>
      </span>
    </el-dialog>
    <el-dialog
            title="稿件迁移"
            :visible.sync="isMigrate"
            width="535px"
            class="column-box"
            :before-close="handleCloseColumTwoPush"
            top="12%"
          >
            <div class="colum-title-box">
              <i style="margin-right: 8px" class="el-icon-info"></i
              >迁移后，该稿件将与原栏目取消关联，并与新栏目进行关联
            </div>
             <div class="tree-box">
                   <a-tree
                    :checkable="true"
                    v-model="checkedSiteIdTwo"
                    :checkStrictly="true"
                    :tree-data="resDataTwo"
                    ref="treeForm"
                    @check="handleNodeClickTwo"
                  >
                  </a-tree>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button  size="medium" @click="()=>{
                    this.isMigrate = false;
                }"
                >取 消</el-button
              >
              <el-button
                :loading="loadingBtn"
                type="primary"
                size="medium"
                @click="selectSaveTwo"
                >确定</el-button
              >
            </span>
          </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import ChooseColumn from "../Manuscripts/choose_column.vue";
import {
  tree,
  list,
  removeColumnManuscript,
  offline,
  selectListById,
  release,
  up,
  down,
  previewOfflineManuscript,
  cancelTop,
  top,
  columnManuscriptBatchCopy,
  ColumnDetailsDataResponse,
  columnManuscriptMigrate
} from "./column_manuscript";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      value: "",
      valueName: "",
      moreData:[],
      states: [],
      statesImportState:[],
      isColumn: false,
      isMigrate:false,
      loadingShow:false,
      loadingBtn:false,
      isMoreChange:false,
      height: 0,
      heightLeft:0,
      isCloseAll: false,
      checkedSiteIdTwo:[],
      selectedKeys: [],
      treeData: [],
      resData: [],
      timeTwo:[],
      resDataTwo:[],
      organization: "1",
      role: undefined,
      selectName: "标题",
      selectValue: 0,
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          ellipsis: true,
          scopedSlots: { customRender: "titleTwo" },
           customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        }
        },
        {
          title: "排序",
          dataIndex: "sort",
          scopedSlots: { customRender: "sort" },
          width: 120,
          ellipsis: true,
        },
        {
          title: "发布时间",
          dataIndex: "releaseTime",
          ellipsis: true,
          width: 200,
        },
        {
          title: "日志",
          dataIndex: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
          width: 120,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 240,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "sort",
          customRender: "sort",
        },
        {
          name: "titleTwo",
          customRender: "titleTwo",
        },
      ],
      columnName: "",
      isSelectRow: true,
      rowKeys: [],
      seeData: {},
      loading: false,
      time: "",
      sortValue: "0",
      selectDatas: [],
      checkedKeys: [],
      codeData: [],
      columnOpenIds: [],
      dialogVisibleTwo:false,
      deleteItem:{},
      deleteShow:false,
      defaultExpandedKeys:[],
      treeLoading:false,
      isDisabled:true,
      columnItemData:{},
      migrateItem:{},
      oldThreeData:[],
      expandedKeys:[],
    };
  },
  components: {
    coententTable,
    ChooseColumn,
  },
  watch:{
    value(val){
        this.treeData = this.oldThreeData;
        this.search()
    }
  },
  mounted() {
    let _this = this;
    let columnId = localStorage.getItem("column_man_id");
    let columnName = localStorage.getItem("column_man_name");
    this.columnOpenIds = JSON.parse(localStorage.getItem("columnOpenIds"));
    if (columnId) {
      this.$nextTick(() => {
        _this.checkedKeys = [Number(columnId)];
        _this.expandedKeys = [Number(columnId)];
        _this.columnId = columnId;
      });
    }
    if (columnName) {
      this.columnName = columnName;
    }
    this.getThreeList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
    this.getLeftMove();
    this.$nextTick(()=>{
        var left = document.getElementById("left");
        var box = document.getElementById("box");
        var right = document.getElementById("right");
        var pagination = document.getElementById("pagination");
        left.style.width = 250 + "px";
        right.style.width = (box.clientWidth - 250 - 5) + "px";
         if((box.clientWidth - 250 - 5) < 1250){
                    
                       document.getElementsByClassName('ant-pagination')[0].style.marginRight = 0;
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'none';
                 }else{
                    
                      document.getElementsByClassName('ant-pagination')[0].style.marginRight = '124px';
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'block';
                 }
        pagination.style.width = (box.clientWidth - 250 + 5) + "px";
    })
   
  },
  methods: {
    // iconOneChange(item){
    //       window.open(item.customUrl)
    // },
     onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.isCloseAll = false;
    },
    filterTree(arr, keyword, first = true) {
      console.log(arr,keyword)
      if (first) {
        //首次传入深度克隆数据防止修改源数据
        arr = JSON.parse(JSON.stringify(arr));
      }
      let emptyArr = [];
      for (let item of arr) {
        if (item.title.includes(keyword)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //     item.children = this.filterTree(item.children, keyword,false);
          // }
          emptyArr.push(item);
          this.expandedKeys.push(item.key)
        } else if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          item.children = this.filterTree(item.children, keyword, false);
          if (item.children.length) {
            emptyArr.push(item);
             this.expandedKeys.push(item.key)
          }
        }
      }
      return emptyArr;
    },
    manuscriptMigration(){
         if (this.rowKeys.length == 0) {
          message.error("请选择操作项");
          return false;
        }
        let reqData = [];
        let arrayData = [];
        for (let index = 0; index < this.selectDatas.length; index++) {
          const element = this.selectDatas[index];
          if(this.rowKeys.indexOf(element.sortId) != -1){
              arrayData.push(element)
          }
          
        }
        for (let index = 0; index < arrayData.length; index++) {
          const element = arrayData[index];
          reqData.push({
              manuscriptId:element.id,
              id:element.sortId,
              importState:element.importState,
              state:element.columnState,
          })
        }
        this.moreData = reqData;
        this.isMoreChange = true;
        this.isMigrate = true;
    },
      handleNodeClickTwo(checkedKeys) {
      this.checkedSiteIdTwo = [].concat(
        checkedKeys.checked[checkedKeys.checked.length - 1]
      );
    },
    removeColumn(){

    },
     getLeftMove(){
            var resize = document.getElementById("resize");
            var left = document.getElementById("left");
            var right = document.getElementById("right");
            var box = document.getElementById("box");
            var pagination = document.getElementById("pagination");
            let  _this = this;
            resize.onmousedown = function(e){
                var startX = e.clientX;
                resize.left = resize.offsetLeft;
                document.onmousemove = function(e){
                var endX = e.clientX;

                var moveLen = resize.left + (endX - startX);
                var maxT = box.clientWidth - resize.offsetWidth;
                if(moveLen<250) moveLen = 250;
                if(moveLen>600) moveLen = 600;  
                if(moveLen>maxT-150) moveLen = maxT-150;

                resize.style.left = moveLen;
                left.style.width = moveLen + "px";
                right.style.width = (box.clientWidth - moveLen - 5) + "px";
                 if((box.clientWidth - moveLen - 5) < 1250){
                       _this.height = document.documentElement.clientHeight - 450;
                       document.getElementsByClassName('ant-pagination')[0].style.marginRight = 0;
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'none';
                 }else{
                      _this.height = document.documentElement.clientHeight - 370;
                      document.getElementsByClassName('ant-pagination')[0].style.marginRight = '124px';
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'block';
                 }
                pagination.style.width = (box.clientWidth - moveLen + 5) + "px";

                }
                document.onmouseup = function(evt){
                document.onmousemove = null;
                document.onmouseup = null; 
                resize.releaseCapture && resize.releaseCapture();
                }
                resize.setCapture && resize.setCapture();
                return false;
            }
        },
    zhiDing(item) {
      this.loading = true;
      top({
        id: item.sortId,
      }).then((res) => {
        if (res.code == 0) {
          this.rowKeys = [];
          this.getList();
        }
      });
    },
    caoSong() {
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      this.isColumn = true;
      this.$nextTick(() => {
        this.$refs.chooseColumn.getColumnTree();
      });
    },
    setColumnIds(data) {
      this.selectChooseIds = data.columnIds;
      if (this.selectChooseIds.length == 0) {
        message.error("请选择抄送的栏目");
        return false;
      }

      let manuscriptIds = [];
       let arrayData = [];
        for (let index = 0; index < this.selectDatas.length; index++) {
          const element = this.selectDatas[index];
          if(this.rowKeys.indexOf(element.sortId) != -1){
              arrayData.push(element)
          }
          
        }
      for (let index = 0; index < arrayData.length; index++) {
        const element = arrayData[index];
        manuscriptIds.push({
            manuscriptId: element.id,
            id:element.sortId,
            importState:element.importState,
            state:element.columnState,
        });
      }

      columnManuscriptBatchCopy({
        manuscriptIds: manuscriptIds,
        columnId: this.selectChooseIds,
      }).then((res) => {
        if (res.code == 0) {
          this.isColumn = false;
          this.rowKeys = [];
          this.pagination.current = 1;
          this.getList();
        }
      });
    },
    colseChooseColumn() {
      this.isColumn = false;
    },
    quZhiDing(item) {
      this.loading = true;
      cancelTop({
        id: item.sortId,
      }).then((res) => {
        if (res.code == 0) {
          this.rowKeys = [];
          this.getList();
        }
      });
    },
    toPath(item) {
      if (item.redirectUrl) {
        window.open(item.redirectUrl);
      } else {
        window.open(item.viewUrl);
      }
    },
     disMigrate(data){
            for (let index = 0; index < data.length; index++) {
                if(data[index].children){
                     data[index].disabled = true;
                    this.disMigrate(data[index].children)
                }
            }
            return data;
        },
    toPathId(item) {
      previewOfflineManuscript({
        id: item.id,
        columnId: this.columnId,
      }).then((res) => {
        if (res.code == 0) {
          window.open("http://" + res.data.previewUrl);
        }
      });
    },
    sort(item, type) {
      if (type) {
        up({
          columnId: this.columnId,
          sortId: item.sortId,
        }).then((res) => {
          if (res.code == 0) {
            this.getList();
          }
        });
      } else {
        down({
          columnId: this.columnId,
          sortId: item.sortId,
        }).then((res) => {
          if (res.code == 0) {
            this.getList();
          }
        });
      }
    },
    search() {
      if(!this.value){
          this.expandedKeys = [this.treeData[0].key];
          return;
      }
      let newData = JSON.parse(JSON.stringify(this.treeData));
      this.treeData = this.filterTree(newData, this.value)
      this.isCloseAll = true;
    },
    see(item) {
      selectListById({
        id: item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.seeData = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    setOffline(item) {
      this.loading = true;
      let array = [
        {
          id: item.sortId,
          manuscriptId: item.id,
          columnId: this.columnId,
        },
      ];
      offline(array).then((res) => {
        if (res.code == 0) {
          this.rowKeys = [];
          this.getList();
        }
      });
    },
    setRelease(item) {
      this.loading = true;
      let array = [
        {
          id: item.sortId,
          manuscriptId: item.id,
          columnId: this.columnId,
        },
      ];
      release(array).then((res) => {
        if (res.code == 0) {
          this.rowKeys = [];
          this.getList();
        }
      });
    },
    handleMenuClick(e) {
      if (e.key == 4 || e.key == 5) {
        return;
      }
      let content = "";
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return;
      }
      if (e.key == 3) {
        content = "确定批量移出吗?";
      }
      if (e.key == 2) {
        content = "确定批量下线吗?";
      }
      if (e.key == 1) {
        content = "确定批量发布吗?";
      }
      const _this = this;
      let arrayData = [];
      let arrayDels = [];
      let arrayDataTwo = [];
        for (let index = 0; index < this.selectDatas.length; index++) {
          const element = this.selectDatas[index];
          if(this.rowKeys.indexOf(element.sortId) != -1){
              arrayDataTwo.push(element)
          }
          
        }
      arrayDataTwo.forEach((element) => {
        arrayData.push({
          id: element.sortId,
          manuscriptId: element.id,
          columnId: this.columnId,
        });
        arrayDels.push({
            manuscriptId: element.id,
            id:element.sortId,
            importState:element.importState,
            state:element.columnState,
        });
      });
      this.$confirm({
        title: "操作提示",
        content,
        centered: true,
        onOk() {
          if (e.key == 1) {
            release(arrayData).then((res) => {
              if (res.code == 0) {
                _this.getList();
                _this.rowKeys = [];
                 _this.selectDatas = [];
                 _this.pagination.current = 1;
              }
            });
          }
          if (e.key == 2) {
            offline(arrayData).then((res) => {
              if (res.code == 0) {
                _this.getList();
                _this.rowKeys = [];
                 _this.selectDatas = [];
                 _this.pagination.current = 1;
              }
            });
          }
          if(e.key == 3){
             removeColumnManuscript({
                columnId:_this.columnId,
                manuscriptIds: arrayDels,
            }).then((res) => {
              if (res) {
                if(res.code == 0){
                  _this.getList();
                   _this.rowKeys = [];
                  _this.selectDatas = [];
                  _this.pagination.current = 1;
                }
              }
            });
          }
        },
        onCancel() {},
        class: "test",
      });
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
      
    },
    selectSaveTwo(){
       if(!this.checkedSiteIdTwo[0]){
            message.error('请选择迁移栏目')
            return;
       }
       this.loadingBtn = true;
       let data = [];
       if(this.isMoreChange){
          data = this.moreData;
       }else{
          data = [{
            manuscriptId:this.migrateItem.id,
            id:this.migrateItem.sortId,
            importState:this.migrateItem.importState,
            state:this.migrateItem.columnState,
          }]
       }
      columnManuscriptMigrate({
          oldColumnId:this.columnId,
          newColumnId:this.checkedSiteIdTwo[0],
          manuscriptIds:data,
      }).then((res)=>{
          if(res.code == 0){
              this.isMigrate = false;
              this.getList();
              this.rowKeys = [];
              this.selectDatas = [];
              this.pagination.current = 1;
              this.checkedSiteIdTwo = [];
          }
           this.loadingBtn = false;
        })
    },
    editAdmin(item) {
      let routeData = this.$router.resolve({
        path: "/index/content/manuscripts_edit",
        query: {
          id: item.id,
          title: "编辑稿件",
          islast: true,
        },
      });
      window.open(routeData.href, '_blank');
    },
    open(item) {
      this.dialogVisibleTwo = true;
      this.deleteItem = item;
    },
    deleteOne(){
        this.deleteShow = true;
        removeColumnManuscript({
          columnId:this.columnId,
          manuscriptIds: [{
             manuscriptId:this.deleteItem.id,
             id:this.deleteItem.sortId,
             importState:this.deleteItem.importState,
             state:this.deleteItem.columnState,
          }],
      }).then((res) => {
        if (res) {
          if(res.code == 0){
            this.deleteShow = false;
            this.dialogVisibleTwo = false;
            this.getList();
          }
        }
      });
    },
    onShowSizeChange(current) {
      console.log();
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys, selectedRows) {
      this.rowKeys = keys;
      this.selectDatas.push(...selectedRows)
      let arrayData = [];
      for (let index = 0; index < this.selectDatas.length; index++) {
          const element = this.selectDatas[index];
          if(this.rowKeys.indexOf(element.sortId) != -1){
              arrayData.push(element)
          }
          
        }
      for (var i = 0; i <  arrayData.length - 1; i++) {
          for (var j = i + 1; j <  arrayData.length; j++) {
              if ( arrayData[i].sortId ==  arrayData[j].sortId) {
                   arrayData.splice(j, 1);
                  j--;
              }
          }
      }
      this.selectDatas = JSON.parse(JSON.stringify(arrayData))
     console.log(this.selectDatas,'ddddddddddddddddd')
    },
     farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
       if(this.timeTwo.length > 0){
        startTime  = this.farmatDate(new Date(this.timeTwo[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.timeTwo[1].toString()).getTime(),'-')
      }
      list({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.valueName,
        siteId: sessionStorage.getItem("siteId"),
        type: this.selectValue,
        columnId: this.columnId,
        sortType: this.sortValue,
        state: this.states.join(','),
        time: this.time,
        importState:this.statesImportState.join(','),
        startTime,
        endTime,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = JSON.parse(JSON.stringify(res.data.records));
          this.pagination.current = res.data.current;
          this.pagination.total = res.data.total;
          this.height = 0;
          if(this.pagination.total > 0){
              var box = document.getElementById("box");
              if((box.clientWidth - 250 - 5) < 1250){
                       this.height = document.documentElement.clientHeight - 450;
                 }else{
                      this.height = document.documentElement.clientHeight - 370;
                 }
            window.onresize = () => {
              return (() => {
                this.heightLeft = `${document.documentElement.clientHeight - 290}px`;
                var left = document.getElementById("left");
                var box = document.getElementById("box");
                var right = document.getElementById("right");
                var pagination = document.getElementById("pagination");
                left.style.width = 250 + "px";
                right.style.width = (box.clientWidth - 250 - 5) + "px";
                if((box.clientWidth - 250 - 5) < 1250){
                       this.height = document.documentElement.clientHeight - 450;
                       document.getElementsByClassName('ant-pagination')[0].style.marginRight = 0;
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'none';
                 }else{
                      this.height = document.documentElement.clientHeight - 370;
                      document.getElementsByClassName('ant-pagination')[0].style.marginRight = '124px';
                       document.getElementsByClassName('ant-pagination-options')[0].style.display = 'block';
                 }
                pagination.style.width = (box.clientWidth - 250 + 5) + "px";
              })();
            };
          }
          this.loading = false;
        }
      });
    },
    getThreeList() {
      const _this = this;
      this.treeLoading = true;
      tree({
        columnName: this.value,
        siteId: sessionStorage.getItem("siteId"),
        orgIds: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      }).then((res) => {
        if (res.code == 0) {
          if ((!localStorage.getItem("column_man_id") ||localStorage.getItem("column_man_id") == "undefined") && res.data.length > 0) {
            this.columnId = res.data[0].id;
            this.columnName = res.data[0].columnName;
            this.isDisabled = res.data[0].sortType == 1?true:false;
            this.checkedKeys = [this.columnId];
            this.expandedKeys = [this.columnId];
          }
          this.getList();
          this.resData = res.data;
          let options = JSON.stringify(res.data)
            .replace(/columnName/g, "title")
            .replace(/id/g, "key");
          _this.treeData = JSON.parse(options);
          _this.resDataTwo = JSON.parse(options);
          _this.resDataTwo = this.disMigrate(_this.resDataTwo)
          _this.treeData = this.disFn(_this.treeData);
          _this.oldThreeData = _this.treeData;
          this.treeLoading = false;
           if(localStorage.getItem("column_man_id")){
              this.disFnThree(this.resData,localStorage.getItem("column_man_id"));
              this.parentIds(this.resData,localStorage.getItem("column_man_id"))
          }else{
              this.checkedKeys = [_this.treeData[0].key];
          }
          this.getcolumnItemData(this.columnId);
        }
      });
    },
    getcolumnItemData(columnId){
        ColumnDetailsDataResponse({
          id:columnId,
        }).then((res)=>{
            if(res.code == 0){
                this.columnItemData = res.data;
            }
        })
    },
    parentIds(data,id){
        for (let index = 0; index < data.length; index++) {
                if(data[index].id  == id){
                    this.defaultExpandedKeys.push(data[index].parentId)
                }else{
                  if(data[index].children){
                      this.parentIds(data[index].children,id)
                  }
                }
            }
    },
    disFnThree(data,id){
         for (let index = 0; index < data.length; index++) {
                if(data[index].id  == id){
                    this.isDisabled = data[index].sortType == 1?true:false;
                    return;
                }else{
                  if(data[index].children){
                      this.disFnThree(data[index].children,id)
                  }
                }
            }
    },
    migrate(item){
        this.isMoreChange = false;
        this.isMigrate = true;
        this.migrateItem = item;
        this.checkedSiteIdTwo = [];
    },
     disFnTwo(data,id){
            for (let index = 0; index < data.length; index++) {
                if(data[index].id  == id){
                   let url = data[index].customUrl;
                    if(url.indexOf('http') != -1 || url.indexOf('https') != -1){
                       window.open(url)
                    }else{
                        window.open(`${sessionStorage.getItem('toWangZhan')}${url}`)
                    }
                   
                    return;
                }else{
                  if(data[index].children){
                      this.disFnTwo(data[index].children,id)
                  }
                }
            }
        },
        handleCloseColumTwoPush(){
            this.isMigrate = false;
        },
    disFn(data){
            for (let index = 0; index < data.length; index++) {
                if(data[index].columnType == 1 && !data[index].children){
                    data[index].scopedSlots =  { switcherIcon:'child' };
                }
                if(data[index].children){
                      this.disFn(data[index].children)
                }
            }
            return data;
        },
    closeAll() {
      this.isCloseAll = true;
      this.$nextTick(() => {
        this.isCloseAll = false;
        this.expandedKeys = [];
      });
    },
    onSelect(key, event) {
      if(key.length == 0){
          return;
      }
      if(event.node._props.dataRef.columnType == 1){
          this.disFnTwo(this.resData,event.node._props.dataRef.key);
      }
      this.time = "";
      this.sortValue = "0";
      this.valueName = "";
      this.columnId = key[0];
      this.isDisabled = event.node._props.dataRef.sortType==1?true:false;
      if (this.columnId) {
        this.columnName = event.node._props.title;
      } else {
        this.columnName = "";
      }
      this.checkedKeys = [this.columnId];
      this.pagination.current = 1;
      localStorage.removeItem("column_man_id");
      localStorage.removeItem("column_man_name");
      localStorage.removeItem("columnOpenIds");
      localStorage.setItem("column_man_id", key[0]);
      localStorage.setItem("column_man_name", event.node._props.title);
      let dems = this.parentTree(this.resData, key[0]);
      let arrayId = [];
      for (let index = 0; index < dems.length; index++) {
        arrayId.push(dems[index].id);
      }
      localStorage.setItem("columnOpenIds", JSON.stringify(arrayId.reverse()));
      this.getList();
      this.getcolumnItemData(this.columnId);
    },
    parentTree(arr, id) {
      //arr 所有的树数据 id 某个子节点的id
      var temp = [];
      var callback = function (nowArr, id) {
        //先定义个函数寻找子节点位置 找到后 再找改节点父元素位置 以此类推
        for (var i = 0; i < nowArr.length; i++) {
          var item = nowArr[i];
          if (item.id === id) {
            temp.push(item);
            callback(arr, item.parentId); //pid 父级ID
            break;
          } else {
            if (item.children) {
              callback(item.children, id); //menus 子节点字段名称
            }
          }
        }
      };
      callback(arr, id);
      return temp; //最后返回
    },
    selectFn(value) {
      this.selectValue = value;
    },
    handleTableChange(pag, filters, sorter) {
      console.log(pag, filters, sorter);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  height: 100%;
  width: 100%;
  max-height: calc(94% - 11px);
  //position: relative;
  .left {
    width: 250px;
    font-size: 14px;
    border-right: solid 1px #f2f3f5;
    height: calc(107.5% - 3px);
    color: #000;
    padding: 24px;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    .ant-tree{
     min-height: 300px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
    /deep/ .ant-btn-primary {
      color: #fff !important;
      background-color: #1890ff !important;
      
    }
  }
  .right {
    flex: 1;
    height: 100%;
    width: 100%;
    font-size: 14px;
    color: #000;
    padding-top: 24px;
    width: 500px;
    .right-name {
      padding-left: 24px;
    }
    .search {
      display: flex;
      margin-left: 24px;
      margin-right: 106px;
      margin-bottom: 20px;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
    }
    
  }
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.right-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  margin-left: 17px;
  flex-wrap: wrap;
  .search {
    margin-left: 6px !important;
  }
  /deep/ .ant-btn,
    .ant-dropdown-trigger {
      height: 40px;
      background: #ecf5ff;
      color: #18abff;
      border-color: #c9e3ff;
      text-align: center;
    }
    /deep/ .ant-dropdown-menu-item {
      text-align: center;
    }
    /deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
  width: 300px;
}

.title-box {
  width: 50px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  background-color: rgba(240, 249, 235, 1);
  color: rgba(103, 194, 58, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(103, 194, 58, 0.3);
  text-align: center;
  }
.table-th {
  width: 126px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table-tn {
  width: 60px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table_one {
  border: solid 1px #ccc;
  width: 100%;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 101px;
  border-radius: 5px;
}
.sort-box {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
   display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn{
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-box-two {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn{
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-two{
   display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
.sort-style {
  width: 43px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  flex:1;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #f4f4f6 1px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 529px);
  padding-right: 24px;
  bottom: 0px;
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.zhi-ding {
    width: 40px;
    height: 20px;
    line-height: 16px;
    border-radius: 3px;
    background-color: rgba(255, 242, 242, 1);
    color: rgba(237, 109, 103, 1);
    font-size: 12px;
    text-align: center;
    font-family: Roboto;
    border: 1px solid rgba(237, 109, 103, 0.3);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
.tui-song{
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(24, 109, 230, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(24, 109, 230, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}
.title-box-two{
  width: 50px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  align-items: center;
  justify-content:center;
}
.icon-box-img{
  cursor: pointer;
}
#resize{
  width:5px;
  height:100%;
  cursor: w-resize;
  float:left;
}
.right-title-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 24px;
  .right-title-box-txt{
    color: rgba(102, 111, 128, 1);
    font-size: 14px;
    text-align: right;
    font-family: Roboto-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    height: 406px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
    padding-bottom: 20px;
  }
  /deep/ .el-dialog__body{
    padding-top: 10px;
    padding-bottom: 13px;
  }
  /deep/ .el-dialog__title{
    color: rgba(48, 49, 51, 1);
    font-size: 18px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-bold;
    font-weight: 600;
  }
  /deep/ .el-dialog__close{
    font-weight: 600;
  }
}
.choose-column-box{
  /deep/ .el-select {
  width: 100%;
}
}
/deep/ .table{
  margin-top: 0px;
}
.search-box{
  position: absolute;
  right: 24px;
}

</style>